function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "myJobs",
  transform: "translate(-36.000000, -210.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-newJob",
  transform: "translate(36.000000, 210.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: 1063299,
  transform: "translate(0.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "11.5555556 12.8888889 16.4444444 12.8888889 16.4444444 14.6666667 11.5555556 14.6666667"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.7160339,14.567632 L18.1015625,14.567632 L18.1015625,15.3906997 C18.1015625,15.8455303 17.7345581,16.2137674 17.28125,16.2137674 L10.71875,16.2137674 C10.2654419,16.2137674 9.8984375,15.8455303 9.8984375,15.3906997 L9.8984375,14.567632 L5.28396608,14.567632 C4.22332761,14.567632 3.28530885,13.8892442 2.94949342,12.8797002 L0,4 L0,21.9752413 C0,23.3367325 1.10400391,24.4444444 2.4609375,24.4444444 L25.5390625,24.4444444 C26.8959961,24.4444444 28,23.3367325 28,21.9752413 L28,4.00064304 L25.050293,12.8797002 C24.7146911,13.8892442 23.7766724,14.567632 22.7160339,14.567632 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.3014648,0 L10.6983203,0 C9.33298263,0 8.22214114,1.08414352 8.22214114,2.41666667 L8.22214114,3.22222222 L1.33333333,3.22222222 L4.44639778,12.3382162 C4.55924453,12.6677806 4.87435549,12.8888889 5.22987638,12.8888889 L9.87292726,12.8888889 L9.87292726,12.0833333 C9.87292726,11.63818 10.2422047,11.2777778 10.6983203,11.2777778 L17.3014648,11.2777778 C17.7575804,11.2777778 18.1268578,11.63818 18.1268578,12.0833333 L18.1268578,12.8888889 L22.7699087,12.8888889 C23.1254296,12.8888889 23.4405405,12.6677806 23.5533873,12.3382162 L26.6666667,3.22222222 L19.7776439,3.22222222 L19.7776439,2.41666667 C19.7776439,1.08414352 18.6668024,0 17.3014648,0 Z M9.87292726,3.22222222 L9.87292726,2.41666667 C9.87292726,1.97214264 10.2428495,1.61111111 10.6983203,1.61111111 L17.3014648,1.61111111 C17.7569356,1.61111111 18.1268578,1.97214264 18.1268578,2.41666667 L18.1268578,3.22222222 L9.87292726,3.22222222 Z",
  id: "Shape"
})), /*#__PURE__*/React.createElement("g", {
  id: 149688,
  transform: "translate(24.000000, 11.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9,0 C4.03753846,0 0,4.03719231 0,9 C0,13.9628077 4.03753846,18 9,18 C13.9624615,18 18,13.9628077 18,9 C18,4.03719231 13.9624615,0 9,0 Z M13.3269231,9.69230769 L9.69230769,9.69230769 L9.69230769,13.5 C9.69230769,13.8821538 9.38215385,14.1923077 9,14.1923077 C8.61784615,14.1923077 8.30769231,13.8821538 8.30769231,13.5 L8.30769231,9.69230769 L4.67307692,9.69230769 C4.29092308,9.69230769 3.98076923,9.38215385 3.98076923,9 C3.98076923,8.61784615 4.29092308,8.30769231 4.67307692,8.30769231 L8.30769231,8.30769231 L8.30769231,4.84615385 C8.30769231,4.464 8.61784615,4.15384615 9,4.15384615 C9.38215385,4.15384615 9.69230769,4.464 9.69230769,4.84615385 L9.69230769,8.30769231 L13.3269231,8.30769231 C13.7090769,8.30769231 14.0192308,8.61784615 14.0192308,9 C14.0192308,9.38215385 13.7090769,9.69230769 13.3269231,9.69230769 Z",
  id: "Shape"
})))));

function SvgIconNewJob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "29px",
    viewBox: "0 0 42 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-newJob") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewJob);
export default __webpack_public_path__ + "static/media/icon-newJob.c528bd0e.svg";
export { ForwardRef as ReactComponent };